<template>
  <component :is="currentLayout">
    <router-view></router-view>
  </component>
</template>

<script>
import MainSiteLayout from './layouts/MainSiteLayout.vue';
import LandpageLayout from './layouts/LandpageLayout.vue';
import ScheduleLayout from './layouts/ScheduleLayout.vue';
import HelpLayout from './layouts/HelpLayout.vue';

export default {
  name: 'app',
  components: {
    MainSiteLayout,
    LandpageLayout,
    ScheduleLayout,
    HelpLayout
  },
  computed: {
    currentLayout() {
      const layout = this.$route.meta.layout || 'MainSiteLayout';
      return layout;
    }
  }
}
</script>